export default __webpack_public_path__ + "static/media/carGear.c69c3524.svg";